import { render, staticRenderFns } from "./dealermanage.vue?vue&type=template&id=16f9eae5&scoped=true"
import script from "./dealermanage.vue?vue&type=script&lang=js"
export * from "./dealermanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f9eae5",
  null
  
)

export default component.exports